<template>
  <div class="news-detail-page">
    <Header modeType="1" />

    <!-- 新闻详情 -->
    <div class="news-detail-container">
      <div class="news-content">
        <h1 class="news-title">{{ newsDetail.title }}</h1>
        <div class="news-info">
          <span class="news-date">{{ newsDetail.createTime }}</span>
        </div>
        <div class="news-main" v-html="newsDetail.content"></div>
      </div>

      <!-- 最新动态 -->
      <div class="latest-news fixed-cache-fix">
        <h3 class="section-title">
          <img src="@/assets/images/about/about-icon.png" alt="">
          最新动态
        </h3>
        <div class="latest-list">
          <div
            v-for="item in latestNews"
            :key="item.infoNo"
            class="latest-item"
            @click="jumpToDetail(item.infoNo)"
          >
            <h4 class="latest-title">{{ item.title }}</h4>
            <span class="latest-date">{{ item.createTime }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="detail-footer">
      <button class="back-btn" @click="goBack">返回列表</button>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { getOfficialWebsiteInfomationInfo, getOfficialWebsiteInfomationList } from '@/apis/news';
import { stripHtml } from '@/common/util/html';

export default {
  name: 'NewsDetail',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      newsDetail: {
        title: '',
        content: '',
        createTime: ''
      },
      latestNews: []
    };
  },
  mounted() {
    this.getNewsDetail();
    this.getLatestNews();
  },
  watch: {
    '$route'(to, from) {
      this.getNewsDetail();
      this.getLatestNews();
    }
  },
  methods: {
    async getNewsDetail() {
      const id = this.$route.params.id;
      if (!id) return;

      try {
        const res = await getOfficialWebsiteInfomationInfo(id);
        if (res) {
          this.newsDetail = {
            title: stripHtml(res.title),
            content: res.content,
            createTime: res.createTime
          };
        }
      } catch (error) {
        console.error('获取新闻详情失败:', error);
        this.$message.error('获取新闻详情失败');
      }
    },
    async getLatestNews() {
      try {
        const params = {
          pageNum: 1,
          pageSize: 6
        };
        const res = await getOfficialWebsiteInfomationList(params);
        if (res.rows) {
          this.latestNews = res.rows
            .filter(item => item.infoNo !== this.$route.params.id)
            .map(item => ({ ...item, title: stripHtml(item.title) }));
        }
      } catch (error) {
        console.error('获取最新动态失败:', error);
      }
    },
    jumpToDetail(id) {
      this.$router.push(`/news/detail/${id}`);
    },
    goBack() {
      this.$router.push('/news');
    }
  }
};
</script>

<style lang="less" scoped>
.news-detail-page {
  background-color: #fff;
}

.crumbs {
  width: 100%;
  min-width: 1200px;
  padding: 20px 0;
  background: #F4F5FB;
}

.news-detail-container {
  width: 100%;
  min-width: 1200px;
  padding: 60px 0;
  background: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  /* 强制使用新的flex渲染上下文，避免浏览器缓存问题 */
  transform: translateZ(0);

  /* 确保flex容器高度 */
  min-height: 800px;

  & > div {
    flex-shrink: 0;
    flex-basis: auto;
  }
}

.news-content {
  width: 827px;
  padding-right: 107px;
  padding-top: 26px;
  box-sizing: border-box;
  border-right: 1px solid #EDEDED;
}

.news-title {
  font-size: 30px;
  font-weight: bold;
  color: #222222;
  line-height: 42px;
  margin-bottom: 30px;
  text-align: center;
}

.news-info {
  text-align: center;
  margin-bottom: 50px;

  .news-date {
    font-size: 16px;
    color: #999999;
  }
}

.news-main {
  font-size: 18px;
  line-height: 34px;
  color: #333333;

  /deep/ img {
    max-width: 100%;
    height: auto;
    margin: 20px 0;
  }

  /deep/ p {
    margin-bottom: 20px;
  }

  /deep/ table {
    width: 100%;
    border-collapse: collapse;
    margin: 20px 0;

    td, th {
      border: 1px solid #ddd;
      padding: 12px;
      text-align: left;
    }
  }
}

.latest-news {
  padding-left: 30px;
  padding-top: 26px;
  color: #222;
  width: 380px;
  /* 强制样式优先级 */
  position: relative;
  z-index: 1;

  .section-title {
    font-size: 24px;
    line-height: 33px;
    font-weight: 500;
    margin-bottom: 35px;

    img {
      width: 33px;
      height: 33px;
      margin-right: 10px;
    }
  }
}

/* 缓存修复样式 */
.fixed-cache-fix {
  /* 强制重新渲染 */
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
  /* 确保内容正常显示 */
  min-height: 1px;
  overflow: visible;
}

.latest-list {
  .latest-item {
    border-bottom: 1px solid #F2F2F2;
    padding: 20px 0 28px;
    cursor: pointer;

    &:last-child {
      border-bottom: none;
    }
  }
}

.latest-title {
  font-size: 20px;
  line-height: 28px;
}

.latest-date {
  color: #8B8FA1;
  font-size: 16px;
  line-height: 22px;
}

.detail-footer {
  margin-top: 60px;
  padding: 30px 0;
  text-align: center;
  border-top: 1px solid #E5E5E5;

  .back-btn {
    padding: 10px 30px;
    background: #FFFFFF;
    color: #0B4FD1;
    border: 1px solid #0B4FD1;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 16px;

    &:hover {
      background: #0B4FD1;
      color: #FFFFFF;
    }
  }
}

// 响应式设计
@media (max-width: 1600px) {
  .news-detail-container {
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  .news-content {
    width: 100%;
    max-width: 827px;
    border-right: none;
    padding-right: 0;
    margin-bottom: 40px;
    border-bottom: 1px solid #EDEDED;
  }

  .latest-news {
    width: 100%;
    max-width: 380px;
    padding-left: 0;
    padding-top: 0;
  }
}
</style>
